// extracted by mini-css-extract-plugin
module.exports = {"yearHeaderFilter":"year-module--yearHeaderFilter--1zCcI","fromTo":"year-module--fromTo--2kpQ9","col":"year-module--col--1shtJ","separator":"year-module--separator--22zGA"};